import { Suspense } from 'react'

import Loader from '@/components/Loader'
import SanitizationContainer from '@/containers/sanitization/sanitization.container'

const Sanitization = () => {
  return (
    <Suspense fallback={<Loader size='sm' />}>
      <SanitizationContainer />
    </Suspense>
  )
}

export default Sanitization
